<template>
    <div>
        <el-row>
            <el-col :span="24">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <!-- <el-breadcrumb-item :to="{ path: '/home/welcome' }">首页</el-breadcrumb-item>
                    <el-breadcrumb-item :to="{ path: '/home/orderInfo' }">订单管理</el-breadcrumb-item> -->
                    <el-breadcrumb-item >首页</el-breadcrumb-item>
                    <el-breadcrumb-item >订单管理</el-breadcrumb-item>
                    <el-breadcrumb-item>订单信息</el-breadcrumb-item>
                </el-breadcrumb>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="24">
                <el-form :inline="true" :model="orderInfo" class="demo-form-inline" label-width="80px" size="mini">
                    <el-form-item label="客户姓名"  v-if="isShowCustomerName">
                        <el-input v-model="orderInfo.condition.customerName" placeholder="客户姓名" clearable></el-input>
                    </el-form-item>
                    <!-- <el-form-item label="实验编号" v-if="isShowExperimentNum">
                        <el-input v-model="orderInfo.condition.experimentNum" placeholder="实验编号" clearable></el-input>
                    </el-form-item> -->
                    <el-form-item label="订单状态">
                        <el-select v-model="orderInfo.condition.orderStatus" filterable placeholder="请选择" clearable>
                            <el-option
                            v-for="item in orderStatuses"
                            :key="item.dictCode"
                            :label="item.dictDesc"
                            :value="item.dictCode">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    
                    <el-form-item label="" >
                        <el-button  @click="queryOrderInfo" size="mini">查询</el-button>
                        <!-- <el-button v-if="isHasAuthority" type="primary" @click="createOrderInfo" size="mini">新增</el-button> -->
                        <!-- <el-button type="primary" @click="batchUpdateStatus" size="mini">批量修改状态</el-button> -->
                        <!-- <el-button v-if="isHasAuthority" type="primary" @click="exportOrder" size="mini">导出</el-button> -->
                    </el-form-item>
                    
                </el-form>
            </el-col>
        </el-row>

        <el-row>
            <el-col :span="24">
                <el-table
                    :data="orderInfos"
                    style="width: 100% height: 100%"
                    v-if="tableHeight"
                    :height="tableHeight"
                    :summary-method="getSummaries"
                    fit
                    size="mini"
                    border
                    v-loading="loading"
                    empty-text="暂无数据"
                    :row-style="rowStyle"
                    @selection-change="handleSelectionChange"
                    @row-click="handleRowClick">
                    <el-table-column prop="experimentNum" fixed label="实验编号"></el-table-column>
                    <el-table-column prop="customerName" label="客户姓名"></el-table-column>
                    <el-table-column prop="carrierName" label="载体名称" show-overflow-tooltip></el-table-column>
                </el-table>
                <div class="block">
                    <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="currentPage"
                    :page-sizes="[10, 20, 50, 100, 500, 1000]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, next, jumper"
                    :total="total">
                    </el-pagination>
                </div>
            </el-col>
        </el-row>

        <el-drawer
            :title="title"
            :visible.sync="drawer"
            :direction="direction"
            :before-close="handleClose"
            size="100%">
                <!-- <OrderInfoUpdate v-if="isUpdate" :key="timer" :orderInfoProp="orderInfoProp"></OrderInfoUpdate> -->
                <OrderInfoView v-if="isView" :key="timer" :orderInfoProp="orderInfoProp"></OrderInfoView>
        </el-drawer> 

    </div>

    

</template>

<script>
import GlobeConstant from '../../../assets/js/GlobeConstant';
// import OrderInfoUpdate from './OrderInfoUpdate.vue';
import OrderInfoView from './OrderInfoView.vue';

export default {
    name:'OrderInfo',
    components: {
        // OrderInfoUpdate,
        OrderInfoView,
    },
    data() {
        return {
            orderInfo:{
                condition:{
                },
                pageNum: 1,
                pageSize:20
            },
            drawer: false,
            direction: 'rtl',
            orderInfos: [],
            currentPage: 1,
            pageSize:20,
            total:10,
            timer:'',
            orderInfoProp:{},
            title:"新增订单",
            dataStatuses:[],
            isReceipts: [],
            dialogFormVisible: false,
            formLabelWidth:"120px",
            titleView: "查看订单",
            drawerView: false,
            isUpdate: true,
            isView: true,
            isHasAuthority: false,
            isShowCustomerName: false,
            isShowCarrierName: false,
            isShowSampleNum: false,
            isShowExperimentNum: false,
            isShowIsPurifying: false,
            isShowIsSequencing: false,
            isShowPayWillingness: false,
            isShowAttributableCustomer: false,
            isShowRegionalAgency: false,
            isShowOverallPlan: false,
            labelStyle:{"text-align":"right"},
            totalOrderAmount: "",
            totalCommissionAmount:"",
            isDirector: false,
            isAdmin: false,
            isHasDel: false,
            confirmationReviews: [],
            isShowQuotationAmount: false,
            tableHeight: "",//表格高度
            confirmationReviewDisabled: false,
            isReceiptDisabled: false,
            isCommissionDisabled: false,
            isCommissions: [],
            orderStatuses:[],
            statusDisabled: true,
            loading: true,
            props: { multiple: true, checkStrictly: true},
            yesOrNo: [],
            payWillingnesses: [],
            multipleSelection: [],
            updateOrder:{},
            updateStatusRules: {
                orderStatus: [
                    { required: true, message: "请选择状态", trigger: "change" },
                ],
            },
            hasUpdate: false,
        }
    },
    methods: {
        update(row) {
            this.title = "修改订单";
            this.drawer = true;
            this.orderInfoProp = row;
            this.timer = new Date().getTime();
            this.isUpdate = true;
            this.isView = false;
        },
        view(row) {
            this.title = "查看订单";
            this.drawer = true;
            this.orderInfoProp = row;
            this.timer = new Date().getTime();
            this.isUpdate = false;
            this.isView = true;
        },
        handleRowClick(row){
            this.title = "查看订单";
            this.drawer = true;
            this.orderInfoProp = row;
            this.timer = new Date().getTime();
            this.isUpdate = false;
            this.isView = true;
        },
        handleSizeChange(val) {
            this.currentPage = 1;
            this.pageSize = val;
            this.queryOrderInfo();
        },
        handleCurrentChange(val) {
            this.currentPage = val;
            this.queryOrderInfo();
        },
        handleClose(done) {
            if(!this.isView) {
                this.$confirm('确认关闭？')
                .then(()=> {
                    done();
                    this.queryOrderInfo();
                })
                .catch(() => {});
            } else {
                done();
            }
        },
        handleCloseView(done) {
            this.$confirm('确认关闭？')
            .then(()=> {
                done();
                this.queryOrderInfo();
            })
            .catch(() => {});
        },
        queryOrderInfo() {
            this.loading = true;
            this.orderInfo.pageNum = this.currentPage;
            this.orderInfo.pageSize = this.pageSize;
            this.$axios.post("/order/find",this.orderInfo).then(
                res=>{
                    if(res.data.status === "success"){
                        this.orderInfos = res.data.result.list;
                        this.total = res.data.result.total;
                    } else {
                        this.$message.error(res.data.message);
                    }
                    this.loading = false;
                },
                error=>{
                    this.$message.error(error.message);
                }
            )
        },
        createOrderInfo() {
            this.title = "新增订单";
            this.drawer = true;
            this.timer = new Date().getTime();
            this.orderInfoProp = {};
            this.isUpdate = true;
            this.isView = false;
        },
        closeDrawer() {
            this.drawer = false;
            this.queryOrderInfo();
        },
        rowStyle({ row }) {
            if(row.dataColor === 'GREEN') {
                let styleJson = {
                    "background-color": "lightgreen"
                }
                return styleJson;
            } else if(row.dataColor === 'RED') {
                let styleJson = {
                    "background-color" : "#F08080"
                }
                return styleJson;
            } else if(row.dataColor === 'YELLOW') {
                let styleJson = {
                    "background-color": "lightyellow"
                }
                return styleJson;
            } else if(row.dataColor === 'GRAY') {
                let styleJson = {
                    "background-color": "lightgray"
                }
                return styleJson;
            } else if(row.dataColor === 'BLUE') {
                let styleJson = {
                    "background-color": "lightblue"
                }
                return styleJson;
            } else if(row.dataColor === 'PURPLE') {
                let styleJson = {
                    "background-color": "#E8B1FF"
                }
                return styleJson;
            } else if(row.dataColor === 'ORANGE') {
                let styleJson = {
                    "background-color": "#FFA500"
                }
                return styleJson;
            }
            
        },
        queryDicts(dictType) {
            let condition = {value:dictType};
            this.$axios.post("/dictionary/findByDictType",condition).then(
                res=>{
                    if(res.data.status === "success"){
                        if(dictType === 'YES_NO') {
                            this.yesOrNo = res.data.result;
                        } else if(dictType === 'ORDER_STATUS') {
                            this.orderStatuses = res.data.result;
                        } else if(dictType === 'PAY_WILLINGNESS') {
                            this.payWillingnesses = res.data.result;
                        }
                    } else {
                        this.$message.error(res.data.message);
                    }
                },
                error=>{
                    this.$message.error(error.message);
                }
            )
        },
        handleDel(row) {
            this.$confirm('您确认删除此订单?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
            }).then(() => {
                this.$axios.post("/orderInfo/delete",row).then(
                    res=>{
                        if(res.data.status === "success"){
                            this.$message({
                                type: 'success',
                                message: '删除成功!'
                            });
                            this.queryOrderInfo();
                        } else {
                            this.$message.error(res.data.message);
                        }
                    },
                    error=>{
                        this.$message.error(error.message);
                    }
                )
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });          
            });
        },
        getTableHeight() {
            let tableH = 300; //距离页面下方的高度
            let tableHeightDetil = window.innerHeight - tableH;
            if (tableHeightDetil <= 200) {
                this.tableHeight = 200;
            } else {
                this.tableHeight = window.innerHeight - tableH;
            }
        },
        handleReduction(row) {
            this.$confirm('您确认还原此订单?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
            }).then(() => {
                this.$axios.post("/orderInfo/reduction",row).then(
                    res=>{
                        if(res.data.status === "success"){
                            this.$message({
                                type: 'success',
                                message: '还原成功!'
                            });
                            this.queryOrderInfo();
                        } else {
                            this.$message.error(res.data.message);
                        }
                    },
                    error=>{
                        this.$message.error(error.message);
                    }
                )
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消还原'
                });          
            });
        },
        exportOrder() {
            this.loading = true;
            this.orderInfo.pageNum = this.currentPage;
            this.orderInfo.pageSize = this.pageSize;
            this.$axios.post("/order/exportExcel",this.orderInfo,
            {
                responseType:"blob"//注意 需要规定后台返回文件流格式
            }).then(
                res=>{
                    if (res) {
                        let fileNames = res.headers['content-disposition'] //获取到Content-Disposition;filename
                        let regFileNames = fileNames.match(/=(.*)$/)[1];
                        const link = document.createElement("a");
                        let blob = new Blob([res.data], { type: "application/vnd.ms-excel" });  //文件流处理
                        link.style.display = "none";  //去除a标签的样式
                        link.href = URL.createObjectURL(blob);
                        link.download = decodeURIComponent(regFileNames);
                        document.body.appendChild(link);
                        //模拟点击事件
                        link.click();
                        this.$message.success('导出成功');
                        this.loading = false;
                    }
                },
                error=>{
                    this.$message.error(error.message);
                    this.loading = false;
                }
            )
        },
        dowloadFile(row) {
            var param = {
                id:row.orderId
            }
            this.$axios.post("/order/downloadFile",param,
            {
                responseType:"blob"//注意 需要规定后台返回文件流格式
            }).then(
                res=>{
                    if (res) {
                        let fileNames = res.headers['content-disposition'] //获取到Content-Disposition;filename
                        let regFileNames = fileNames.match(/=(.*)$/)[1];
                        const link = document.createElement("a");
                        let blob = new Blob([res.data], { type: "application/vnd.ms-excel" });  //文件流处理
                        link.style.display = "none";  //去除a标签的样式
                        link.href = URL.createObjectURL(blob);
                        link.download = decodeURIComponent(regFileNames);
                        document.body.appendChild(link);
                        //模拟点击事件
                        link.click();
                        this.$message.success('下载成功');
                        this.loading = false;
                    }
                },
                error=>{
                    this.$message.error(error.message);
                    this.loading = false;
                }
            )
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        batchUpdateStatus() {
            if(this.multipleSelection.length === 0) {
                this.$message.error("请至少选择一条数据！");
                return;
            }
            this.dialogFormVisible = true;
            var formName = 'updateStatusForm';
            if(this.$refs[formName]) {
                this.$refs[formName].resetFields();
            }

        },
        doUpdateStatus(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    let updateParam = {
                        ids : this.multipleSelection.map(item => item.orderId),
                        orderStatus : this.updateOrder.orderStatus
                    }
                    this.$axios.post("/order/batchUpdateStatus",updateParam).then(
                        res=>{
                            if(res.data.status === "success"){
                                this.$message.success("批量修改状态成功！");
                                this.dialogFormVisible = false;
                                this.queryOrderInfo();
                            } else {
                                this.$message.error(res.data.message);
                            }
                        },
                        error=>{
                            this.$message.error(error.message);
                        }
                    )
                } else {
                    return false;
                }
            });
        },
        getSummaries(param) {
            const { columns, data } = param
            const sums = []
            // 解决elementUI table合计行初始页面不显示问题  this.height由父组件传递过来 this.theight未表格绑定的高度
            //延时执行   要不然会一直刷新
            if(!this.hasUpdate) {
                window.setTimeout(() => {
                    let height = this.tableHeight;
                    if (this.tableHeight === height) {
                        this.tableHeight += 0.5;
                    } else {
                        this.tableHeight = height;
                    }
                }, 1000);
                this.hasUpdate = true;
            }
            
            columns.forEach((column, index) => {
                if (index === 0) {
                    sums[index] = '合计'
                    return
                }
                if (column.property === 'positiveCloneNum' || column.property === 'companySg' || column.property === 'companyKtr' || column.property === 'companyQk' || column.property === 'companyHc'
                    || column.property === 'companyJkr'|| column.property === 'orderAmount'|| column.property === 'customSettlementAmount'|| column.property === 'agentSettlementAmount') {
                    const values = data.map(item => Number(item[column.property]))
                    if (!values.every(value => isNaN(value))) {
                        sums[index] = values.reduce((prev, curr) => {
                        const value = Number(curr)
                        if (!isNaN(value)) {
                            return prev + curr
                        } else {
                            return prev
                        }
                        }, 0)
                        if (column.property === 'positiveCloneNum') {
                            sums[index] += ' 个'
                        } else if (column.property === 'companySg') {
                            sums[index] += ' 次'
                        } else if (column.property === 'companyKtr') {
                            sums[index] += ' 次'
                        } else if (column.property === 'companyQk') {
                            sums[index] += ' 次'
                        } else if (column.property === 'companyHc') {
                            sums[index] += ' 次'
                        } else if (column.property === 'companyJkr') {
                            sums[index] += ' 次'
                        } else if (column.property === 'orderAmount') {
                            sums[index] += ' 元'
                        } else if (column.property === 'customSettlementAmount') {
                            sums[index] += ' 元'
                        } else if (column.property === 'agentSettlementAmount') {
                            sums[index] += ' 元'
                        }else {
                            sums[index] += ' '
                        }
                    } else {
                        sums[index] = ''
                    }
                }
            })
            return sums
        }
    },
    mounted() {
        // this.$bus.$on(GlobeConstant.orderinfoupdate_to_orderinfo_close, this.closeDrawer);
        this.queryOrderInfo();
        this.user = JSON.parse(window.localStorage.getItem("user"));
        if(this.user.roleCode === 'ADMIN' || this.user.roleCode === 'SUPER') {
            this.isHasAuthority = true;
            this.isAdmin = true;
            this.isShowCustomerName = true;
            this.isShowCarrierName = true;
            this.isShowSampleNum = true;
            this.isShowExperimentNum = true;
            this.isShowIsPurifying = true;
            this.isShowIsSequencing = true;
            this.isShowPayWillingness = true;
            this.isShowAttributableCustomer = true;
            this.isShowRegionalAgency = true;
            this.isShowOverallPlan = true;
        } else if(this.user.roleCode === 'AGENT') {
            this.isShowCustomerName = true;
        } else if(this.user.roleCode === 'RESPONSIBLE') {
            this.isShowCustomerName = true;
            this.isShowPayWillingness = true;
        } else if(this.user.roleCode === 'ORDINARY') {
            this.isShowPayWillingness = true;
        }
        this.queryDicts("YES_NO");
        this.queryDicts("ORDER_STATUS");
        this.queryDicts("PAY_WILLINGNESS");
        let _this = this;
        window.onresize = () => {
        if (_this.resizeFlag) {
            clearTimeout(_this.resizeFlag);
        }
        _this.resizeFlag = setTimeout(() => {
            _this.getTableHeight();
            _this.resizeFlag = null;
        }, 100);
        };

    },
    beforeDestroy() {
        this.$bus.$off(GlobeConstant.orderinfoupdate_to_orderinfo_close);
    },
    created() {
        this.getTableHeight();
    }
    
}


</script>

<style scoped>

   .el-form {
       margin-top: 30px;
   }
   .block {
       text-align: right;
       margin-top: 10px;
   }
   .el-select {
        width: 220px;
    }

    .el-input {
        width: 220px;
    }
    .el-date-picker {
        width: 200px;
        background-color: green;
    }
    .el-cascader {
        width: 220px;
    }
    .margin-top {
        margin-top: 10px;
    }
    /* ::v-deep .el-table tbody tr:hover>td { 
        background-color: transparent !important;
    }
    ::v-deep .el-table__fixed-right tbody tr:hover>td {
        background-color: transparent !important;
    } */

    ::v-deep  .el-table .el-table__body tr.hover-row > td{
        background-color: #FFC0CB !important
    }

    ::v-deep  .el-tablle--enable-row-hover .el-table__body tr:hover > td{
        background-color:#FFC0CB !important
    }

    .emptyBg {
        display:block;
    }

    

</style>